let Photos1960=[
  {
    "NameEN": "1960",
    "Image": "un11",
    "CaptionEN": "Cuban Premier Fidel Castro gave his first UNGA speech in 1960 [AP Photo]",
    "CaptionAR": " فيدل كاسترو يلقي خطابه الأول في الجمعية العامة عام 1960 عندما كان رئيسا للوزراء إثر نجاح الثورة الكوبية (أسوشيتد برس)"
  },
  {
    "NameEN": null,
    "Image": "un14",
    "CaptionEN": "Israeli soldiers stand next to the Western Wall in Jerusalem's old city, 1967 [Reuters]",
    "CaptionAR": "جندي إسرائيلي يقف قرب حائط البراق في القدس القديمة عام 1967 (رويترز)"
  },
  {
    "NameEN": null,
    "Image": "un13",
    "CaptionEN": "\"Peaceful coexistence cannot be limited to the powerful countries if we want to ensure world peace.\" - Ernesto Che Guevara, 1964 [Getty Images]",
    "CaptionAR": "الثائر الأممي أرنستو تشي غيفارا يقول عام 1964 \"إذا أردنا ضمان السلم العالمي، فلا يمكن إبقاء التعايش السلمي رهنا بإرادة القوى العظمى\" (غيتي)"
  },
  {
    "NameEN": null,
    "Image": "un15",
    "CaptionEN": "Children celebrate Algeria's independence from French colonial rule, 1962 [AP Photo]",
    "CaptionAR": "أطفال يحتفلون باستقلال الجزائر عن فرنسا عام 1962 (أسوشيتد برس)"
  },
  {
    "NameEN": null,
    "Image": "un12",
    "CaptionEN": "US President John F Kennedy delivering a speech in front of the Soviet delegation, 1961 [Getty Images]",
    "CaptionAR": "الرئيس الأميركي جون كينيدي يلقي خطابه قبالة الوفد السوفياتي عام 1961 (غيتي)"
  }
]
export default Photos1960